import React, { useEffect, useState } from 'react';
import { audiencesApi } from '../../api/audiences';
import Modal from '../../components/base/Modal';
import ModalFooter from '../../components/base/Modal/ModalFooter';
import ModalTitle from '../../components/base/Modal/ModalTitle';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../components/base/Notifications';
import styles from './Contacts.module.scss';
import { useContactsParams } from './useContactsParams';

const CreateListModal = ({ closeModal }) => {
  const { params } = useContactsParams();
  const [createList, listCreationResult] =
    audiencesApi.useCreateListFromContactsMutation();
  const [listName, setListName] = useState('');

  const handleSave = () => {
    createList({
      name: listName,
      status: params.status,
      filters: params.filters,
    });
  };

  useEffect(() => {
    if (listCreationResult.status === 'fulfilled') {
      closeModal();
      showSuccessMessage(`List ${listName} created successfully`);
      listCreationResult.reset();
    } else if (listCreationResult.status === 'rejected') {
      if (
        listCreationResult.error?.data?.name &&
        listCreationResult.error.data.name.length > 0 &&
        listCreationResult.error.data.name[0] ===
          'A list with this name already exists for your team.'
      ) {
        showErrorMessage('A list with this name already exists.');
      } else {
        showErrorMessage('An error occurred while creating the list.');
        closeModal();
      }
      listCreationResult.reset();
    }
  }, [closeModal, listCreationResult, listName]);

  return (
    <Modal
      onCancel={closeModal}
      loading={listCreationResult.status === 'pending'}
    >
      <ModalTitle title="Save as List" />

      <input
        type="text"
        maxLength={100}
        className={`form-control ${styles.input}`}
        placeholder="Add list name here"
        value={listName}
        onChange={(e) => setListName(e.target.value)}
      />

      <ModalFooter>
        <button
          type="button"
          className="outline-button border border-1"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          type="button"
          className="regular-button"
          onClick={handleSave}
          disabled={!listName}
        >
          Save
        </button>
      </ModalFooter>
    </Modal>
  );
};

const CreateListButton = () => {
  const [showSaveListModal, setShowSaveListModal] = useState(false);
  return (
    <div className={styles.create_list_button}>
      <button
        type="button"
        className="outline-button border border-1"
        onClick={() => setShowSaveListModal(true)}
      >
        Save as List
      </button>
      {showSaveListModal && (
        <CreateListModal closeModal={() => setShowSaveListModal(false)} />
      )}
    </div>
  );
};

export default CreateListButton;
